module.exports = __webpack_public_path__ + "img/lock-keyhole-open.90bd270f.svg";